import { GeometryRenderConfigInterface, MarkerPropertiesInterface } from "modules/construction-work/src/Common/interface";
import { DEFAULT_OPACITY } from "modules/construction-work/src/Common/const/MarkerConfigsConst";
import {
    Geometry,
    Map,
    VectorLayer,
    AnyMarkerSymbol,
    AnySymbol,
} from "maptalks";

export default abstract class GeometryRendererAbstract {
    protected config: GeometryRenderConfigInterface;

    constructor(config: GeometryRenderConfigInterface) {
        this.config = config;
    }

    abstract render(geometry: Geometry, markerLayer: VectorLayer, map: Map): void

    protected createMarkerSymbol(properties: MarkerPropertiesInterface): AnyMarkerSymbol {
        let baseSymbol: AnyMarkerSymbol = {};

        if (properties.settingsMarker?.svgMap === null) {
            baseSymbol = {
                markerFile: properties.settingsMarker?.imgMap,
                markerWidth: this.config.markerWidth,
                markerHeight: this.config.markerHeight,
            };
        } else {
            baseSymbol = { markerFile: this.getSvgIcon(properties.settingsMarker?.svgMap) };
        }
        if (this.config.markerOffset) {
            baseSymbol.markerDy = this.config.markerOffset.dy;
        }

        return baseSymbol;
    }

    protected createNotificationSymbol(notificationSvg: string): AnyMarkerSymbol {
        return {
            markerFile: this.getSvgIcon(notificationSvg),
            markerWidth: this.config.notificationSize,
            markerHeight: this.config.notificationSize,
            markerDy: this.config.notificationOffset.dy,
            markerDx: this.config.notificationOffset.dx,
        };
    }

    protected buildMarkerSymbols(
        properties: MarkerPropertiesInterface,
    ): AnyMarkerSymbol[] {
        const symbols: AnyMarkerSymbol[] = [
            this.createMarkerSymbol(properties)
        ];

        if (!properties.isRead) {
            symbols.push(this.createNotificationSymbol(properties.notificationSvg));
        }

        return symbols;
    }

    protected getSvgIcon(icon: string): string {
        // TODO (надо бы разобраться с этим так как не работает, но GPT говорит что должно быть ОК) вырезаем атрибуты width и height для того чтобы иконка заполняла заданные размеры из конфига
        // icon = icon.replace(/[\r\n]+/g, '');
        // icon = icon.replace(/<svg\b([^>]*)>/i, (match, attrs) => {
        //     let cleaned = attrs;
        //
        //     // Удаляем только width=... и height=... (строго атрибуты svg)
        //     cleaned = cleaned.replace(
        //         /(?:^|\s)(width|height)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi,
        //         ''
        //     ).trim();
        //
        //     // Проверяем наличие preserveAspectRatio
        //     if (!/preserveAspectRatio\s*=/.test(cleaned)) {
        //         cleaned += ' preserveAspectRatio="xMidYMid slice"';
        //     }
        //
        //     return `<svg ${cleaned}>`;
        // });

        return 'data:image/svg+xml;base64,' + btoa(icon);
    }

    protected createLineSymbol(color: string, width: number): AnySymbol[] {
        return [{
            lineColor: color,
            lineWidth: width,
            polygonFill: color,
            polygonOpacity: DEFAULT_OPACITY,
        }];
    }
}
